import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-80" }

import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import Chart from 'chart.js/auto';


export default /*@__PURE__*/_defineComponent({
  __name: 'Chart',
  props: {
    chartData: {}
  },
  setup(__props: any) {

const props = __props;

const chartCanvas = ref<HTMLCanvasElement | null>(null);
let chart: Chart | null = null;

const yAxisRange = computed(() => {
  const rawMin = Math.min(...props.chartData.map((item) => item.value));
  const rawMax = Math.max(...props.chartData.map((item) => item.value));

  const min = Math.floor(rawMin * 4) / 4; // Round down to nearest 0.25
  const max = Math.ceil(rawMax * 4) / 4;  // Round up to nearest 0.25

  return { min, max };
});

const updateChart = () => {
  if (!chartCanvas.value) return;

  const ctx = chartCanvas.value.getContext('2d');
  if (!ctx) return;

  if (chart) {
    chart.destroy();
  }

  chart = new Chart(ctx, {
    type: 'line',
    data: {
      labels: [
        ...props.chartData.map((item) => item.label),
      ],
      datasets: [
        {
          label: 'Weekly Average (based on Copper Spot Price)',
          data: props.chartData.map((item) => item.value),
          borderColor: '#3b82f6',
          backgroundColor: '#3b82f6',
          borderWidth: 2,
          pointRadius: 4,
          pointBackgroundColor: '#3b82f6',
          tension: 0.1,
          fill: false,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 20,
            padding: 30,
            textAlign: 'left',
            font: {
              family: "'Inter', 'Helvetica', 'Arial', sans-serif",
              size: 16,
            },
          },
        },
        tooltip: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || '';
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += '$' + context.parsed.y.toFixed(2) + '/lb';
              }
              return label;
            },
          },
        },
      },
      scales: {
        y: {
          beginAtZero: false,
          suggestedMin: yAxisRange.value.min - 0.25,
          suggestedMax: yAxisRange.value.max + 0.25,
          ticks: {
            stepSize: 0.25,
            callback: function (value) {
              return '$ ' + Number(value).toFixed(2);
            },
            font: {
              family: "'Inter', 'Helvetica', 'Arial', sans-serif",
              size: 16,
            },
          },
          grid: {
            color: '#f3f4f6',
          },
        },
        x: {
          grid: {
            display: false,
          },
          ticks: {
            font: {
              family: "'Inter', 'Helvetica', 'Arial', sans-serif",
              size: 16,
            },
          },
        },
      },
    },
  });
};

watch(
  () => props.chartData,
  () => {
    updateChart();
  },
  { deep: true },
);

onMounted(() => {
  updateChart();
});

onUnmounted(() => {
  if (chart) {
    chart.destroy();
    chart = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", {
      ref_key: "chartCanvas",
      ref: chartCanvas
    }, null, 512)
  ]))
}
}

})